// react
import styled from 'styled-components';
import { css } from 'styled-components';

// components
import { BaseField, BaseFieldProps, Button } from '@/components/atoms';

import { FieldDef } from '@/components/organisms/EditorFields/fieldHelper';

import { EditorFields } from '@/components/organisms/EditorFields/EditorFields';

/**
 * QuestionTable is the question table component.
 */
export const QuestionTable = ({
  value,
  fieldValue,
  fieldKey,
  onChange,
  isDisabled = false,
  ...props
}: QuestionTableProps) => {
  const newSubFields: { [k: string]: FieldDef } = {};

  fieldValue.field.subfields?.forEach((subField) => {
    newSubFields[subField.id?.toString() || ''] = subField;
  });

  let myValue = value?.[fieldKey] ? JSON.parse(value?.[fieldKey]) : [{}];
  if (myValue.length === 0) {
    myValue = [{}];
  }

  return (
    <>
      <BaseField {...props}>
        <StyledTable>
          {myValue.map((v: any, i: number) => {
            return (
              <StyledTableRow key={i}>
                <StyledInnerEditorFields>
                  <EditorFields
                    fields={newSubFields}
                    value={v}
                    onChange={(w) => {
                      const newValue = [...myValue];
                      newValue[i] = w;
                      onChange(JSON.stringify(newValue));
                    }}
                    isDisabled={isDisabled}
                  />
                </StyledInnerEditorFields>
                {myValue.length >= 2 && (
                  <Button
                    ariaLabel={'remove more entries'}
                    variant='secondary'
                    isDisabled={isDisabled}
                    onPress={() =>
                      onChange(
                        JSON.stringify([
                          ...myValue.slice(0, i),
                          ...myValue.slice(i + 1),
                        ]),
                      )
                    }
                  >
                    Remove
                  </Button>
                )}
              </StyledTableRow>
            );
          })}
          {myValue.length === 0 ? (
            <StyledTableRow>
              <NoTableDataMessage>{fieldValue.placeholder}</NoTableDataMessage>
            </StyledTableRow>
          ) : null}
        </StyledTable>
      </BaseField>
      <Button
        ariaLabel={'add more entries'}
        isFullWidth
        variant='secondary'
        onPress={() => onChange(JSON.stringify([...myValue, {}]))}
        iconLeft={'plus'}
        isDisabled={isDisabled}
      >
        Add another
      </Button>
    </>
  );
};

const StyledInnerEditorFields = styled.div`
  gap: ${(props) => props.theme.spacing[16]};
  width: 100%;
  padding: ${(props) => props.theme.spacing[12]} 0;
`;

const StyledTable = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[16]};
`;

const StyledTableRow = styled.div`
  ${(props) => css`
    border: 1px solid ${props.theme.color.neutral[60]};
    border-radius: 16px;
  `}
  width: 100%;
  padding: ${(props) => props.theme.spacing[12]}
    ${(props) => props.theme.spacing[16]};
  gap: ${(props) => props.theme.spacing[16]};
`;

const NoTableDataMessage = styled.div`
  width: 100%;
  text-align: center;
`;

interface QuestionTableProps extends BaseFieldProps {
  value?: any;
  fieldValue: FieldDef;
  fieldKey: string;
  onChange: (newVal: string) => void;
}

QuestionTable.displayName = 'QuestionTable';

export default QuestionTable;
